import { createApp } from 'vue'
import { postErrorLog } from '@/assets/api/request.js'
import './assets/css/init.css'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { postLogRobot } from '@/assets/api/login.js'
import { extractErrorInfo } from '@/utils/extractErrorInfo.js'
// 不再引入原样式
// import 'element-plus/dist/index.css'
// 修改element组件默认样式
import 'vant/es/toast/style'
import './assets/css/element-plus.scss'
import 'vant'
import App from './App.vue'
import router, { device } from './router'
import store from './store'
// 注册自定义指令
import { defineDirective } from './directive/backgroundPermission'
import { packageMask } from './directive/packageMask'

const app = createApp(App)
app.use(device)

// 注册lelement-plus的图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store).use(router).use(ElementPlus, {
  // size: 'small',
  zIndex: 2000,
  locale: zhCn,
})

// 这里影响热重载，暂时禁止可以恢复热重载
// app.config.globalProperties.$tinymce = tinymce
// app.use(VueTinymce)

app.config.globalProperties.$log = (...rest) => {
  if (rest[0] === '') {
    for (let i = 0; i < rest.length; i++) {
      const item = rest[i]
      const json = Object.prototype.toString.call(item) === '[object Object]' ? JSON.parse(JSON.stringify(rest[i])) : item
      console.log(`log_${i + 1}`, json)
    }
  } else {
    console.log(...rest)
  }
}

// app.config.errorHandler = async (error, instance, info) => {
//   /**
//    * key 企业微信机器人秘钥
//    * project 项目名称
//    * context 错误信息1
//    */
//   const params = {
//     key: 'bc6d110f-4afa-40ac-8804-e8a18af89327',
//     project: '微风智选渠道后台',
//     context: error.stack + '\n' + info,
//   }
//   // await postLogRobot(params)
// }

// 注册自定义指令
defineDirective(app)
packageMask(app, store)
// 挂载
app.mount('#app')
